import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import b122Table from './modules/b122Table'
import storeUtils from './modules/storeUtils'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  modules: {
    auth,
    b122Table,
    storeUtils,
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js